import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { DOWNLOAD_MODE, KeyBoardAction } from '../../commonUtil/constants';

const isDomNodeInTarget = (event, domNode) => {
    if (event.path) {
        if (event.path.indexOf(domNode) > -1) return false;
    } else {
        // for ie
        let checkTarget = event.target;
        while (checkTarget !== domNode && checkTarget !== document.body) {
            checkTarget = checkTarget.parentNode;
        }

        if (checkTarget === domNode) return false;
    }

    return true;
};

const FormatsDropdown = (props) => {
    const { className, onClick, placement, downloadUrls, originalFormat, onClose } = props;
    const dropdownRef = useRef();
    const listRef = useRef();
    const { t } = useTranslation();
    const dropdownItems = downloadUrls.map((item) => {
        const name = item.assetType === DOWNLOAD_MODE.PDFOnly ?
            t('LIVE_SEND_VIEWER_DOWNLOAD_AS_FORMAT', { format: 'PDF' }) :
            t('LIVE_SEND_VIEWER_DOWNLOAD_AS_FORMAT', { format: originalFormat.toUpperCase() });
        return {
            ...item,
            name
        };
    });
    const outerClick = (event) => {
        if (dropdownRef.current) {
            if (dropdownRef.current.contains(event.target) && event.target.className.indexOf('seismic-theme2019-dropdown-title') >= 0) return;
        } else {
            document.body.removeEventListener('click', outerClick);
            return;
        }

        if (isDomNodeInTarget(event, listRef.current)) {
            if (onClose) { onClose(); }
        }
    };

    useEffect(() => {
        document.body.addEventListener('click', outerClick);
        const iframes = document.body.getElementsByTagName('iframe');
        if (iframes && iframes[0] && iframes[0].title === 'PSPDFKit') {
            iframes[0].contentDocument.addEventListener('click', outerClick);
        }

        return () => {
            document.body.removeEventListener('click', outerClick);
            if (iframes && iframes[0] && iframes[0].title === 'PSPDFKit') {
                iframes[0].contentDocument.removeEventListener('click', outerClick);
            }
        };
    }, []);

    const onClickUrl = (item) => {
        onClick(item);
    };

    const onKeydown = (e, item) => {
        if (e.keyCode === KeyBoardAction.enter) {
            onClick(item);
        }
    };

    const dropdownWrapperClass = classNames('engagement-viewer-formats-dropdown', className, placement);
    return (
        <div className={dropdownWrapperClass} ref={dropdownRef}>
            <ul className="download-format-list" ref={listRef}>
                {
                    dropdownItems.map(item => (<li key={item.name}>
                        <span className="download-format-list-item"
                            tabIndex="0"
                            role="button"
                            onClick={() => { onClickUrl(item); }}
                            onKeyDown={(e) => { onKeydown(e, item); }}>{item.name}</span>
                    </li>))
                }
            </ul>
        </div>
    );
};

export default FormatsDropdown;
